import * as Yup from 'yup';
import { fields } from '@synergy/utils';

import { CurrencyPriceFormValues } from './models/form-values/currency-price-form-values';
import { ProductPriceFormValues } from './models/form-values/product-price-form-values';
import { ScalePriceFormValues } from './models/form-values/scale-price-form-values';
import { SpecialPriceFormValues } from './models/form-values/special-price-form-values';

const fieldNames = fields<ProductPriceFormValues>();
const currencyPriceFieldNames = fields<CurrencyPriceFormValues>();
const specialPriceFieldNames = fields<SpecialPriceFormValues>();
const scalePriceFieldNames = fields<ScalePriceFormValues>();

export const productDetailPricesValidationSchema = Yup.object().shape({
    [fieldNames.isBestPrice]: Yup.boolean(),
    [fieldNames.priceReferenceQuantity]: Yup.number()
        .required('app.error.required')
        .moreThan(0, 'app.error.greaterZero'),
    [fieldNames.priceQuantity]: Yup.number().required('app.error.required').moreThan(0, 'app.error.greaterZero'),
    [fieldNames.taxClass]: Yup.string().required('app.error.required'),
    [fieldNames.currencyPrices]: Yup.array().of(
        Yup.object().shape({
            [currencyPriceFieldNames.mainPrice]: Yup.number()
                .typeError('app.error.required')
                .required('app.error.required'),
            [currencyPriceFieldNames.specialPrices]: Yup.array().of(
                Yup.object().shape(
                    {
                        [specialPriceFieldNames.minimumQuantity]: Yup.number()
                            .nullable()
                            .moreThan(0, 'app.error.greaterZero'),
                        [specialPriceFieldNames.price]: Yup.number().when(['startDate', 'endDate'], {
                            is: (startDate: Date, endDate: Date) => startDate || endDate,
                            then: Yup.number().typeError('app.error.required').required('app.error.required'),
                        }),
                        [specialPriceFieldNames.startDate]: Yup.date()
                            .nullable()
                            .when(['price', 'endDate'], {
                                is: (price: number, endDate: Date) => price || endDate,
                                then: Yup.date().typeError('app.error.required').required('app.error.required'),
                            }),
                        [specialPriceFieldNames.endDate]: Yup.date()
                            .nullable()
                            .when(['price', 'startDate'], {
                                is: (price: number, startDate: Date) => price || startDate,
                                then: Yup.date()
                                    .typeError('app.error.required')
                                    .required('app.error.required')
                                    .min(Yup.ref('startDate'), 'app.error.minStartDate'),
                            }),
                    },
                    [
                        ['startDate', 'endDate'],
                        ['price', 'endDate'],
                        ['price', 'startDate'],
                    ]
                )
            ),
            [currencyPriceFieldNames.scalePrices]: Yup.array().of(
                Yup.object().shape(
                    {
                        [scalePriceFieldNames.price]: Yup.number().when('quantity', {
                            is: (quantity: number) => quantity,
                            then: Yup.number().typeError('app.error.required').required('app.error.required'),
                        }),
                        [scalePriceFieldNames.quantity]: Yup.number().when('price', {
                            is: (price: number) => price,
                            then: Yup.number()
                                .moreThan(0, 'app.error.greaterZero')
                                .typeError('app.error.required')
                                .required('app.error.required'),
                        }),
                    },
                    [['price', 'quantity']]
                )
            ),
        })
    ),
});
